// UserMessage.js
import React from 'react';
import { motion } from 'framer-motion';
import { fileTypeFromUrl } from '../utils/attachments';
import Document from './MessageTypes/Document';
import Image from './MessageTypes/Image';
import Video from './MessageTypes/Video';
import Time from './Time';

const InteractiveMessage = ({ text, time, options, onButtonReplyClick, src }) => {
  const animationProps = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.5 }
  };
  const fileType = fileTypeFromUrl(src);

  return (
    <div className="flex mb-2 justify-start w-full">
      <motion.div {...animationProps} className="w-full">
        <div className="w-fit max-w-[75%] text-sm p-2 px-3 break-words rounded-tl-2xl rounded-tr-2xl bg-callbell-light-gray text-black rounded-br-2xl">
          {fileType === 'image' && <Image src={src} />}
          {fileType === 'document' && (
            <div className="text-sm p-2 break-words rounded-tl-2xl rounded-tr-2xl bg-callbell-light-gray text-black">
              <Document src={src} />
            </div>
          )}
          {fileType === 'video' && <Video src={src} />}
          <div className={src ? 'mt-2' : 'm-2'}>{text}</div>
        </div>
        <div className="mt-1 w-full inline">
          {options.map((option, index) => {
            return (
              <button
                key={index}
                className="text-sm p-2 px-3 break-words rounded-lg bg-blue-100 text-cyan-700 mx-1 mt-2 hover:bg-slate-600 hover:text-white"
                onClick={() => onButtonReplyClick(option.title)}
              >
                {option.title}
              </button>
            );
          })}
        </div>
        <Time time={time} senderType="user" />
      </motion.div>
    </div>
  );
};

export default InteractiveMessage;
